// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-1k0flNac","footer":"footer-8zoTlc8S","right_link":"right_link-QDjLdxTt","f_ico1":"f_ico1-36PTme4v","v_dellink":"v_dellink-2yosxIV3"};